import { useState } from "react";
import { useDebounceCallback, useResizeObserver } from 'usehooks-ts';

/**
 * Хук для получения размеров HTML-элемента по ref.
 * @template T - Тип HTML-элемента (по умолчанию HTMLElement)
 * @param {import("react").RefObject<T>} ref - React ref на элемент
 * @returns {{ width: number, height: number }} Объект с шириной и высотой
 */
export function useResizeObserverDebounced(ref) {
    const [{ width, height }, setSize] = useState({ width: undefined, height: undefined, })
    const onResize = useDebounceCallback(setSize, 100)
    useResizeObserver({ ref, onResize, box: 'border-box', })
    return { width, height }
}
